import { ChangeBoardPermsView } from 'app/scripts/views/board-menu/ChangeBoardPermsView';

class ChangeBoardCommentingPermsView extends ChangeBoardPermsView {
  static initClass() {
    this.prototype.viewTitleKey = 'commenting permissions';
  }
  getTemplate() {
    return require('app/scripts/views/templates/board_menu_commenting');
  }
  getPerm() {
    return 'comments';
  }
}
ChangeBoardCommentingPermsView.initClass();
export { ChangeBoardCommentingPermsView };
